import { Alert, AlertTitle, Box, Checkbox, FormControlLabel, Table, TableCell, TableRow } from '@mui/material'
import React, { useState } from 'react'
import { findValueByKey, tableCellValues } from './helper'

import './style.css'
import Loader from 'src/pages/common/Loader';
import WarningMessage from './WarningMessage';
import { useDispatch, useSelector } from 'react-redux';
import { selectDataListSectionIds, updateDataListSectionId } from 'src/features/rfqDataSlice';

function SummaryViewBox({ closeForm, summaryViewData, summaryStructureData, reGenerate, time, warning = true, isFromView = false, sectionId = null }) {
    // Initialize an array to hold the sum of each column
    const columnSums = Array(summaryStructureData?.headers?.length).fill(0);
    const [hovered, setHovered] = useState(false);
    const dispatch = useDispatch();

    // Get the current selected section IDs from Redux store
    const selectedSectionIds = useSelector(selectDataListSectionIds);



    const handleCheckboxChange = (event) => {
        const isChecked = event.target.checked;
        let updatedIds = [];

        if (isChecked) {
            // Append sectionId if not already in the list
            updatedIds = [...selectedSectionIds, sectionId];
        } else {
            // Remove sectionId if unchecked
            updatedIds = selectedSectionIds?.filter(id => id !== sectionId);
        }

       
        // Dispatch action to update Redux state
        dispatch(updateDataListSectionId({ data: updatedIds }));
    };



    const calculateRowTotal = (item) => {
        return summaryStructureData?.headers?.reduce((sum, item2, index) => {

            const cellValue = parseFloat(tableCellValues(item, item2, summaryStructureData, false)) || 0;
            columnSums[index] += cellValue;  // Add to the corresponding column sum
            return sum + cellValue;
        }, 0);
    };

    return (
        <div
            style={{ position: "relative", display: "inlineBlock" }}
            onMouseEnter={() => setHovered(true)}
            onMouseLeave={() => setHovered(false)}
        >

            {isFromView && <Box
                sx={{
                    position: "absolute",
                    top: "25px",
                    left: "0px",
                    width: hovered ? "200px" : "0px",
                    overflow: "hidden",
                    whiteSpace: "nowrap",
                    transition: "width 0.4s ease-in-out",
                    background: "white",
                    padding: hovered ? "5px" : "0px",
                    border: hovered ? "1px solid #ccc" : "none",
                    borderRadius: "4px",
                    display: "flex",
                    alignItems: "center",
                }}
            >
                <FormControlLabel
                    control={<Checkbox size="small"
                        checked={Array.isArray(selectedSectionIds) && selectedSectionIds.includes(sectionId)}
                        onChange={handleCheckboxChange} />}
                    label={hovered ? "Show detailed data list" : ""}
                />
            </Box>}

            {(summaryStructureData?.headerTitles?.length > 0) && (summaryViewData.length > 0) && warning && <WarningMessage time={time} />}
            {(summaryStructureData?.headerTitles?.length > 0) && (summaryViewData.length > 0) && <Table className="summary-table" sx={{ minWidth: 650, marginTop: '20px' }} aria-label="simple table">
                {/* Header Row */}
                <TableRow>
                    <TableCell style={{ padding: 0 }}>
                        <div className="tableHeads">#</div>
                    </TableCell>
                    {summaryStructureData?.headerTitles?.map((item, i) => (
                        <TableCell key={i} style={{ padding: 0 }}>
                            <div className="tableHeads">{item}</div>
                        </TableCell>
                    ))}
                    <TableCell style={{ padding: 0 }}>
                        <div className="tableHeads">Total Sum Insured</div>
                    </TableCell>
                </TableRow>

                {/* Table Content Section */}
                {summaryStructureData?.summary?.map((item, i) => {
                    const total = calculateRowTotal(item);
                    return (
                        <TableRow key={`row-label-${i}`}>
                            <TableCell style={{ padding: 0 }}>
                                <div className="tableColumn">{i + 1}</div> {/* Order number */}
                            </TableCell>
                            {summaryStructureData?.headers?.map((item2, j) => (
                                <TableCell key={`cell-${i}-${j}`} style={{ padding: 0 }}>
                                    <div className="tableColumn">
                                        {tableCellValues(item, item2, summaryStructureData)}
                                    </div>
                                </TableCell>
                            ))}
                            {/* Total Column */}
                            <TableCell key={`total_suminsured_right-${i}`} style={{ padding: 0 }}>
                                <div className="tableHeads">{total}</div>
                            </TableCell>
                        </TableRow>
                    );
                })}

                {/* Footer Row for Vertical Sums */}
                <TableRow>
                    {/* Merged Cells for the "Total" label */}
                    <TableCell colSpan={Math.abs(summaryStructureData.riskFactorHeaders.length - summaryStructureData.headers.length) + 1} style={{ padding: 0 }}>
                        <div className="tableHeads" style={{ paddingLeft: '10px', textAlign: 'left' }}>Total</div>
                    </TableCell>
                    {/* Total Sum for Each Column */}
                    {summaryStructureData?.riskFactorHeaders?.map((item, i) => (
                        <TableCell key={`footer-total-${i + 1}`} style={{ padding: 0 }}>
                            <div className="tableHeads"> {columnSums[i + 1]}</div>
                        </TableCell>
                    ))}
                    {/* Grand Total Cell */}
                    <TableCell key="footer-total-grand" style={{ padding: 0 }}>
                        <div className="tableHeads">Grand Total: {columnSums.reduce((a, b) => a + b, 0)}</div>
                    </TableCell>
                </TableRow>
            </Table>}
            {(summaryStructureData?.length < 1) && <Loader />}

        </div>
    );
}



export default SummaryViewBox